module.exports = __webpack_public_path__ + "img/800x800.59807f81.jpg";